import React, { useState } from "react";
import SocialLinks from "./SocialLinks";

const EMAIL = "andyfransisko1@gmail.com";

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      window.location.href = `mailto:${EMAIL}`;
    }
  };

  return (
    <section id="lets-talk" className="py-10">
      <h3 className="font-bold text-3xl">
        Let's <span className="text-teal-500">Talk</span>
      </h3>

      <div className="mt-12 about-bg rounded-xl px-6 md:px-12 py-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
        <div className="flex-1">
          <h4 className="font-bold text-2xl">Have a project in mind?</h4>
          <p className="gray-font mt-3 leading-relaxed">
            Feel free to reach out via email, I'm always open to discussing
            new opportunities and ideas.
          </p>

          <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-3">
            <a
              href={`mailto:${EMAIL}`}
              className="bg-teal-500 hover:bg-teal-400 text-black font-semibold px-5 py-3 rounded-lg transition-colors text-center break-all"
            >
              <i className="fa fa-envelope mr-2" aria-hidden="true"></i>
              {EMAIL}
            </a>
            <button
              type="button"
              onClick={copyEmail}
              className="border border-gray-600 hover:border-teal-500 hover:text-teal-400 font-medium px-5 py-3 rounded-lg transition-colors"
            >
              {copied ? (
                <>
                  <i className="fa fa-check mr-2 text-teal-400" aria-hidden="true"></i>
                  Copied!
                </>
              ) : (
                <>
                  <i className="fa fa-copy mr-2" aria-hidden="true"></i>
                  Copy Email
                </>
              )}
            </button>
          </div>
        </div>

        <div className="lg:text-right">
          <p className="gray-font mb-4">Follow my social media.</p>
          <SocialLinks className="lg:justify-end" />
        </div>
      </div>
    </section>
  );
}
